'use strict';

import React, { Component, useDebugValue } from 'react';
import { render } from 'react-dom';
import { AgGridReact } from '@ag-grid-community/react';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { RowGroupingModule } from '@ag-grid-enterprise/row-grouping';
import { MenuModule } from '@ag-grid-enterprise/menu';
// import Consignmentforceclose from '../m';
import { AllModules, GridOptionsWrapper } from '@ag-grid-enterprise/all-modules';
import { ColumnsToolPanelModule } from '@ag-grid-enterprise/column-tool-panel';
import { FiltersToolPanelModule } from '@ag-grid-enterprise/filter-tool-panel';
import { SetFilterModule } from '@ag-grid-enterprise/set-filter';
import '@ag-grid-community/core/dist/styles/ag-grid.css';
import "@ag-grid-enterprise/all-modules/dist/styles/ag-theme-balham.css";
import SweetAlert from 'react-bootstrap-sweetalert';
import * as Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';
import $ from 'jquery';
import { getDDMMYYYY, getHyphenYYYYMMDD,getHyphenDDMMMYYYYHHMM,getHyphenDDMMMYYYY,getHyphenYYYYMMDDHHMMSS,getHyphenDDMMYYYYHHMMSS,getDDMMYYYYHHMMSS, getYYYYMMDD, getYYYYMMDDHHMMSS } from '../common/utils'; 
import download from 'js-file-download';

// const $ = window.$;
window.jQuery = $;
window.$ = $;
var redirectURL = require('../redirectURL');
var moment = require('moment');
var filecontent="";
var googleAnalytics = require("../common/googleanalytics");
var CELL_DIMENSION_SIZE = 90;




export default class FFgridExportsData extends Component {
  constructor(props) {
    super(props);
      this.state = {
        modules : AllModules,
        defaultColDef: {
            sortable: true,
            filter: true,
            editable: true,
        },
        eventAction: null,
        show: false,
        frameworkComponents : {
        },
        modified_by:"",
        basicTitle:'',
        reasonforceclose:"",
        bulkslide:"",
        file:"",
        uploadFile:"",
        basicType:"default",
        loadshow:'show-n',
        forceCloseRowNode : "",
        forceclosedata:"",
        csvcontent:"",
        sliderForceCloseTranslate:"",
        overly:'',
        rowData:[],
        bulkslide:"",
        showDiv:"",
        uploadDivWidth:"",
        mapinfo:"",
        dealer:"",
        sliderCommentTranslate:"",
        commentsRowData:"",
        consignment_code:"",
        sliderRouteTranslate:"",
        maptruckno:"",
        routeTruck:	"",
        rownode:"",
        googelRoutes:"",
        file:"",
        rowSelection:'multiple',
        sliderForceCloseTranslate:"",
        maptruckno:"",
        rowModelhighchartoptionsType: 'enterprise',
        rowGroupPanelShow: 'always',
            statusBar: {
        statusPanels: [
          {
          statusPanel: "agTotalAndFilteredRowCountComponent",
          align: "left"
          },
          {
          statusPanel: "agTotalRowCountComponent",
          align: "center"
          },
          { statusPanel: "agFilteredRowCountComponent" },
          { statusPanel: "agSelectedRowCountComponent" },
          { statusPanel: "agAggregationComponent" }
        ]
            },
        paginationPageSize:200,
        geofencelist:[],
        geoFenceData:"",
        sideBar: {
          toolPanels: [
            {
            id: "columns",
            labelDefault: "Columns",
            labelKey: "columns",
            iconKey: "columns",
            toolPanel: "agColumnsToolPanel"
            },
            {
            id: "filters",
            labelDefault: "Filters",
            labelKey: "filters",
            iconKey: "filter",
            toolPanel: "agFiltersToolPanel"
            }
          ]
        },
        animateRows: true,
        dept_code:"",
        pagetitle:"",
        markDeliverRowNode : "",
        markDeliverData:"",
        sliderMarkDeliverTranslate:"",
        csvData:0,
        overly:"show-m",
        loadshow:"show-m",
        holidayEvents : [],
        showCalendar : "show-m",
        showGridData : "show-m",
        ffRowData : [],
        invoiceData:[]
        //components : {datepicker:getDatePicker()}
    }
}
componentDidMount(){

    var ffRowData = this.props.ffRowData;
    console.log(ffRowData,"ffRowData")
    this.setState({
        ffRowData : ffRowData,
    })
}
onRecommGridReady = params => {
    this.gridApi = params.api;  
    //console.log("Grid is: ", params);
    this.gridColumnApi = params.columnApi;
};
onRecommGridState = () =>{
    //console.log(this.gridApi);

    /*Get  Current Columns State and Store in this.colState */
    this.colState = this.gridColumnApi.getColumnState();

    /*Get Current RowGroup Columns State and Store in this.rowGroupState */
    this.rowGroupState = this.gridColumnApi.getRowGroupColumns();

    /*Get Current Pivot Columns State and Store in this.pivotColumns, 
    * User should enable the Pivot mode.*/
    this.pivotColumns = this.gridColumnApi.getPivotColumns();
            
    /*Get Current Filter State and Store in window.filterState */
    window.filterState = this.gridApi.getFilterModel();
    this.gridApi.setFilterModel(window.filterState);
}

onClickHideAll(){
    this.setState({
    loadshow:'show-n',
    overly:'show-n',
    bulkslide:"",
    invoiceData:[]
    
    });
    
}

showGrid(){
    this.setState({
        showCalendar : "show-n",
        showGridData  : "show-m"
    })
}

closeAlert = () => {
    this.setState({
        show: false
    });
}



viewDetails(e){
    if(e.colDef.field == "air_way_bill")
    {
        var ringiFile = e.data.air_way_bill
        if(ringiFile !='')
        {
            var rngParam = {
                ringiFile : ringiFile,
            }
            redirectURL.post("/consignments/downloadExportsRingiFile",rngParam).then((response)=>{
                console.log("dowlad response ",response)
                download(response.data, ringiFile)
            }).catch(function(error){
                console.log(error);
            })
        }
    }
}

downloadRingiFile = (ringiFile) => {
    //console.log(ringiFile)
    if(ringiFile !='')
    {
        var rngParam = {
            ringiFile : ringiFile,
        }
        redirectURL.post("/consignments/downloadExportsRingiFile",rngParam,{
            responseType: 'blob'
        }).then((response)=>{
            console.log("dowlad response ",response)
            download(response.data, ringiFile)
        }).catch(function(error){
            console.log(error);
        })
    }
}

  render() {
    var columnwithDefs = [      
        {
            field:'_id',
            headerName:'',
            colId:"_id",
            //pinned:"left",
            width: 72,
            cellRenderer:function(params){
                let basestring = params.data._id;
                let encryptedstring = window.btoa(basestring);
                var htmloption = '<a href="/editffaircargoexportsform/'+encryptedstring+'/2" class="custom-btn label label-success"><i class="icofont icofont-edit"></i> Edit</a>';
                return htmloption;
            }            
        },
        {
            headerName: "Job No",
            field: "job_no",
            width:130,
            filter: true,
            resizable: true,           
        },  
        {
            headerName: "Invoice No",
            field: "commercial_invoice",
            width:130,
            filter: true,
            resizable: true,           
        }, 
        {
            headerName: "Date",
            field: "date",
            width:130,
            filter: true,
            resizable: true,
            valueGetter: function(params){
                if(params.data.date !=undefined && params.data.date !='')
                {
                    return moment.parseZone(params.data.date).format("DD-MM-YYYY")
                }
            }
        },
        {
            headerName: "Department Name",
            field: "dept_name",
            width:120,
            filter: true,
            resizable: true,           
        },
        {
            headerName: "Indenter Name",
            field: "indenter_name",
            width:130,
            filter: true,
            resizable: true,           
        },
        {
            headerName: "Mobile No",
            field: "mobile",
            width:100,
            filter: true,
            resizable: true,           
        },
        {
            headerName: "Indenter Email",
            field: "indenter_email",
            width:130,
            filter: true,
            resizable: true,           
        },
        {
            headerName: "Fright Forwarder",
            field: "assign_to_ff",
            width:180,
            filter: true,
            resizable: true,           
        },
        {
            headerName: "Handover date at IGI",
            field: "hand_over_date_at_igi",
            width:130,
            filter: true,
            resizable: true,
            valueGetter: function(params){
                if(params.data.hand_over_date_at_igi !=undefined && params.data.hand_over_date_at_igi !="undefined")
                {
                    return moment.parseZone(params.data.hand_over_date_at_igi).format("DD-MM-YYYY")
                }
            }           
        },
        {
            headerName: "Final shipment receiving date",
            field: "final_shipment_receiving_date",
            width:130,
            filter: true,
            resizable: true,
            valueGetter: function(params){
                if(params.data.final_shipment_receiving_date !=undefined && params.data.final_shipment_receiving_date !='')
                {
                    return moment.parseZone(params.data.final_shipment_receiving_date).format("DD-MM-YYYY")
                }
            }         
        },
        {
            headerName: "Airway Bill No",
            field: "air_way_bill_no",
            width:130,
            filter: true,
            resizable: true,           
        },
        {
            headerName: "Airway bill date",
            field: "air_way_bill_date",
            width:130,
            filter: true,
            resizable: true,
            valueGetter: function(params){
                if(params.data.air_way_bill_date !=undefined && params.data.air_way_bill_date !='')
                {
                    return moment.parseZone(params.data.air_way_bill_date).format("DD-MM-YYYY")
                }
            }         
        },
        {
            headerName: "Airway bill",
            field: "air_way_bill",
            width:130,
            filter: true,
            resizable: true,           
        },   
        {
            headerName: "Airline Name",
            field: "airline_name",
            width:130,
            filter: true,
            resizable: true,           
        },
        {
            headerName: "ETD",
            field: "etd",
            width:130,
            filter: true,
            resizable: true,
            valueGetter: function(params){
                if(params.data.etd !=undefined && params.data.etd !='')
                {
                    return moment.parseZone(params.data.etd).format("DD-MM-YYYY")
                }
            }            
        },
        {
            headerName: "ATD",
            field: "atd",
            width:130,
            filter: true,
            resizable: true,
            valueGetter: function(params){
                if(params.data.atd !=undefined && params.data.atd !='')
                {
                    return moment.parseZone(params.data.atd).format("DD-MM-YYYY")
                }
            }            
        },  
        {
            headerName: "Transit Port",
            field: "transit_port",
            width:130,
            filter: true,
            resizable: true,           
        },  
        {
            headerName: "Transit Port Airline",
            field: "transit_port_airline",
            width:130,
            filter: true,
            resizable: true,           
        },
        {
            headerName: "ETA Transit Port",
            field: "eta_transit_port",
            width:130,
            filter: true,
            resizable: true,
            valueGetter: function(params){
                if(params.data.eta_transit_port !=undefined && params.data.eta_transit_port !='')
                {
                    return moment.parseZone(params.data.eta_transit_port).format("DD-MM-YYYY")
                }
            }            
        },
        {
            headerName: "ATA Transit Port",
            field: "ata_transit_port",
            width:130,
            filter: true,
            resizable: true,
            valueGetter: function(params){
                if(params.data.ata_transit_port !=undefined && params.data.ata_transit_port !='')
                {
                    return moment.parseZone(params.data.ata_transit_port).format("DD-MM-YYYY")
                }
            }            
        },
        {
            headerName: "ETD Transit Port",
            field: "etd_transit_port",
            width:130,
            filter: true,
            resizable: true,
            valueGetter: function(params){
                if(params.data.etd_transit_port !=undefined && params.data.etd_transit_port !='')
                {
                    return moment.parseZone(params.data.etd_transit_port).format("DD-MM-YYYY")
                }
            }            
        },
        {
            headerName: "ATD Transit Port",
            field: "atd_transit_port",
            width:130,
            filter: true,
            resizable: true,
            valueGetter: function(params){
                if(params.data.atd_transit_port !=undefined && params.data.atd_transit_port !='')
                {
                    return moment.parseZone(params.data.atd_transit_port).format("DD-MM-YYYY")
                }
            }            
        },
        {
            headerName: "Final Port Name",
            field: "final_port_name",
            width:150,
            filter: true,
            resizable: true,           
        },
        {
            headerName: "ETA Destination Port",
            field: "eta_destination_port",
            width:130,
            filter: true,
            resizable: true,
            valueGetter: function(params){
                if(params.data.eta_destination_port !=undefined && params.data.eta_destination_port !='')
                {
                    return moment.parseZone(params.data.eta_destination_port).format("DD-MM-YYYY")
                }
            }            
        },
        {
            headerName: "ATA Destination Port",
            field: "ata_destination_port",
            width:130,
            filter: true,
            resizable: true,
            valueGetter: function(params){
                if(params.data.ata_destination_port !=undefined && params.data.ata_destination_port !='')
                {
                    return moment.parseZone(params.data.ata_destination_port).format("DD-MM-YYYY")
                }
            }            
        }
    ]

        
    return (
        <div class="row">
            <SweetAlert
                show={this.state.show}
                type={this.state.basicType}
                title={this.state.basicTitle}
                onConfirm={this.closeAlert}
            >
            </SweetAlert>
            <div className="col-xl-12">
                <div id="myGrid" style={{width:"100%",height:"478px"}} className={"ag-theme-balham"}>
                <AgGridReact
                    modules={this.state.modules}
                    //columnDefs={columnwithDefs}
                    columnDefs={columnwithDefs}
                    defaultColDef={this.state.defaultColDef}
                    rowData={this.props.ffRowData}
                    enableCharts={false}
                    // autoGroupColumnDef={this.state.autoGroupColumnDef}
                    onGridReady={this.onRecommGridReady}
                    onGridState={this.onRecommGridState}
                    frameworkComponents={this.state.frameworkComponents}
                    statusBar={this.state.statusBar}
                    sideBar={this.state.sideBar}
                    stopEditingWhenGridLosesFocus= {true}
                    paginationPageSize={this.state.paginationPageSize}
                    pagination={true}
                    gridOptions={{
                        context: { componentParent: this }
                    }}
                    onCellClicked={this.viewDetails.bind(this)}
                    // components={this.state.components}
                    />
                </div>
            </div>
            <div className={"slide-r "+(this.state.bulkslide)} style={{overflow:"hidden"}}>
            <h3 className="subH">
                {this.state.sliderTitle}
                <span className="float-right fclose" style={{marginRight:"12px",padding:"1px 8px",marginTop:"-2px"}} onClick={this.onClickHideAll.bind(this)}>x</span>
            </h3>
            <div className="slide-r-body" style={{position:"relative"}}>
                {(this.state.invoiceData.length > 0) ?                         
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-sm-12">
                                <table className="table table-bordered tptinfo">
                                    <thead>
                                        <tr>
                                            <th>Documents</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.invoiceData.map((e, index) => (
                                        <tr>
                                            <td style={{cursor:"pointer"}} onClick={() => this.downloadRingiFile(e.invoice_file)}>{e.invoice_file}</td>
                                        </tr>
                                            ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                : ""}
            </div>
        </div>
        </div>
        

    );
  }
}